import { render, staticRenderFns } from "./LockerFilterButton.vue?vue&type=template&id=af220824&scoped=true&lang=pug&"
import script from "./LockerFilterButton.vue?vue&type=script&lang=js&"
export * from "./LockerFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./LockerFilterButton.vue?vue&type=style&index=0&id=af220824&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af220824",
  null
  
)

export default component.exports